import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { API_URL } from '../../common/constant';
import FreeListing_property from '../../component/FreeListing_property';
import Loader from '../../component/loader/Loader';
import Navbar from '../../component/Navbar';
import BottomNav from '../../component/BottomNav';
import { Helmet } from 'react-helmet';

const BlogDetail = () => {
    const { slug } = useParams();
    const [blog, setBlog] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchBlog = async () => {
            try {
                const response = await axios.get(`${API_URL}/api/blog/blogs/${slug}`);
                setBlog(response.data.blog);
            } catch (err) {
                setError("Failed to load blog. Please try again later.");
            } finally {
                setLoading(false);
            }
        };
        fetchBlog();
    }, [slug]);

    if (loading) return <Loader />;
    if (error) return <p className="text-red-500">{error}</p>;
    if (!blog) return <p className="text-gray-500">Blog not found.</p>;

    return (
        <>

            <Helmet>
                <title>{blog.metaTitle}</title>
                <meta name="description" content={blog.metaDescription} />
                <meta property="og:title" content={blog.metaTitle} />
                <meta property="og:description" content={blog.metaDescription} />
                <meta property="og:image" content={`${API_URL}/uploads/blogs/${blog._id}/${blog.featureImages[0]}`} />
                <meta property="og:url" content={window.location.href} />
            </Helmet>
            <div className=" mx-auto p-4 md:p-8 grid grid-cols-1 md:grid-cols-3 gap-8">
                {/* Blog Content - 2/3 Screen Width */}
                <div className="md:col-span-2">
                    <img
                        src={`${API_URL}/uploads/blogs/${blog._id}/${blog.featureImages[0]}`}
                        alt={blog.title}
                        className="w-full h-80 object-cover rounded-lg shadow-md"
                    />
                    <h1 className="text-3xl font-bold text-green-800 mt-6">{blog.title}</h1>
                    <div className=" text-gray-600 mt-4" dangerouslySetInnerHTML={{ __html: blog.content }} />
                </div>

                {/* Free Listing Component - 1/3 Screen Width (Desktop) */}
                <div className="hidden md:block">
                    <FreeListing_property />
                </div>

                {/* Free Listing Component (Mobile) */}
                <div className="md:hidden mt-8">
                    <FreeListing_property />
                </div>
            </div>
            <BottomNav />


        </>
    );
};

export default BlogDetail;
